<div class="po-xl-6 po-lg-6 po-md-12 po-sm-12 late-cards">
    <po-widget>
      <span class="po-font-text-bold">Quantidade total por classificação do local {{typeClassificationLocation}}</span>
      <div class="icon-loading" *ngIf="loading && !errorApi">
        <app-loading-icon></app-loading-icon>
      </div>
      <div class="po-text-center po-pt-5" *ngIf="errorApi">
        <app-error [message]="message"></app-error>
      </div>
      <div *ngIf="!loading && !errorApi">
        <fusioncharts width="100%" height="300" type="column2d" [dataSource]="dataSource">
        </fusioncharts>
      </div>
    </po-widget>
  </div>
